module.exports = __webpack_public_path__ + "img/new_order_form_icon.4b37b23e.svg";